import styled from 'styled-components';

import { BaseStyle, ReactTableStyles } from '@nhl/nhl-breakaway-ui';

export const AwardsHeader = styled.div<{ $rowNumber: number }>`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    color: ${({ theme }) => theme.Text.secondary};
    background: ${({ theme }) => theme.Surface.disabled};
    border-top: ${({ $rowNumber, theme }) => ($rowNumber === 0 ? `1px solid ${theme.Surface.border}` : 'initial')};
    height: 56px;
    padding: 20px 16px;
`;

export const AwardsTable = styled.div`
    ${ReactTableStyles.CommonTableStyling};
`;
